var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "form-minimize-btn", attrs: { title: "紧凑模式" } },
    [
      _c(
        "el-checkbox",
        {
          staticStyle: { position: "relative", top: "-5px" },
          model: {
            value: _vm.formInlineData,
            callback: function($$v) {
              _vm.formInlineData = $$v
            },
            expression: "formInlineData"
          }
        },
        [_vm._v("紧凑")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-557e6be3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-557e6be3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/FormInlineMode.vue
// module id = 1046
// module chunks = 75